<div class="dialog">
  <div class="dialog-header">
    <div>
      <h2>Additional Product Approval Required</h2>
      @if (data.providerName || data.planName) {
        <p>
          {{ data.providerName || 'Provider' }}@if (data.planName) {
          <span> - {{ data.planName }}</span>
        }
      </p>
    }
  </div>
  <button mat-icon-button type="button" aria-label="Close" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="dialog-copy">
  In order to offer this product to your employees, Wallit may need to complete an approval or setup review first. This is typically a one-time process. The Wallit team will review your request and reach out within the next 2 business days if any additional information is needed. We won’t be able to enable this product for employees until that step is complete.
</div>

<mat-form-field appearance="outline" class="note-field">
  <mat-label>Optional note for the Wallit team</mat-label>
  <textarea
    matInput
    rows="5"
    [(ngModel)]="note"
    placeholder="Add any context that will help us prepare this approval."
  ></textarea>
</mat-form-field>

<div class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="send()">Send</button>
</div>
</div>
